import { Paginator } from '@app/classes';
import { VacationYtdAdjustmentHistory } from '@app/models/payroll/vacation-ytd-adjustment-history';
import { Table } from '@app/modules/table/classes/table.class';
import {
    AdjustmentAmountColumn,
    DateLastAdjustedColumn,
    MessageColumn,
    PayPeriodNumberColumn,
    TimeOffMoneyBalanceColumn,
} from './columns';
export class VacationYtdAdjusmentsHistoryTable extends Table {
    constructor(private employeeId: number | string) {
        super();
        this.boot();
    }

    setColumns(): void {
        this.columns = [
            new PayPeriodNumberColumn(),
            new DateLastAdjustedColumn(),
            new AdjustmentAmountColumn(),
            new MessageColumn(),
            new TimeOffMoneyBalanceColumn(),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(VacationYtdAdjustmentHistory.param('employee', this.employeeId), {
            pageSize: 25,
        });
    }
}
